import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import cx from "classnames";
import { useRef } from "react";

import Logo from "assets/images/RepeatMD_myRepeat.svg";
import { handleLinkClick } from "utils/androidByPassDeepLinkClick";
import { getAdminUrl } from "utils/functions";

type RepeatMDFooterProps = {
  showLinks?: boolean;
  showShopTerms?: boolean;
};

export const RepeatMDFooter = (props: RepeatMDFooterProps) => {
  const logo = <Logo className="fill-dark-grey" />;
  const anchorRef = useRef(null);
  return (
    <div>
      <div className={cx("flex w-full items-center justify-center", "p-4")}>
        <div className={cx("mr-1 text-body3 text-dark-grey")}>Powered by</div>
        {logo}
      </div>
      {props.showLinks && (
        <div className="flex items-center justify-center gap-6 px-5 pb-7 pt-3">
          <button
            className="text-bold3 text-secondary"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/terms.html" })
            }
          >
            Terms of service
          </button>
          <button
            className="text-bold3 text-secondary"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/privacy-policy.html" })
            }
          >
            Privacy policy
          </button>
          {!Capacitor.isNativePlatform() && (
            <a
              ref={anchorRef}
              className="text-bold3 text-secondary"
              href={getAdminUrl()}
              target="_self"
              rel="noopener noreferrer"
              onClick={() => {
                handleLinkClick(anchorRef);
              }}
            >
              Admin
            </a>
          )}
        </div>
      )}
      {props.showShopTerms && (
        <span
          className={cx(
            "flex w-full justify-center gap-1 pb-1 text-chip text-primary",
            "flex-wrap font-normal"
          )}
        >
          By placing this order you agree to our{" "}
          <button
            className="text-brand-color"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/privacy-policy.html" })
            }
          >
            Privacy policy
          </button>
          and{" "}
          <button
            className="text-brand-color"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/terms.html" })
            }
          >
            Terms of Use
          </button>
        </span>
      )}
    </div>
  );
};
